<template>
    <div>
        <div id="myChart" style="width:100%;height:500px; overflow-x:scroll"></div>
    </div>
</template>

<script>
    import Lockr from 'lockr'
    import {identifyRate} from "@/api/teacher";
    export default {
        name: 'DailyLearn',
        data() {
            return {
                msg: '',
                studyTime1: '',
                studyNum1: '',
                studyNum2: '',
            }
        },
        mounted() {
            this.getStudyInfo()

        },
        methods: {
            getStudyInfo() {
                let params = {
                    token: Lockr.get('teacherToken'),
                    student_id: this.$route.query.student_id
                }
                identifyRate(params).then(result => {
                    if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                        this.studyTime1= result.data.result1.name
                        this.studyNum1= result.data.result1.value
                        this.studyNum2= result.data.result2.value
                        this.drawLine();
                    }
                })
            },
            drawLine() {
                // 基于准备好的dom，初始化echarts实例
                let myChart = this.$echarts.init(document.getElementById('myChart'))
                // 绘制图表
                let colors = ['#21D23A', '#FB7F46',];
                myChart.setOption({
                    color: colors,
                    grid: {
                        top: '25%',//距上边距
                    },
                    title: {
                        text: '【最近一周单词学习系统使用时间明细图】',
                        x: 'center',
                        y: 'top',
                        textAlign: 'left',
                        textStyle: {
                            color: '#333'
                        }
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: ['', '', '', '单词数量', '语法数量'],
                        textStyle: {
                            color: '#333',
                            fontSize: 15
                        }
                    },
                    toolbox: {
                        show: true,
                        feature: {
                            magicType: {show: true, type: ['line', 'bar']},
                        },
                        axisLabel: {
                            show: true,
                            interval: 'auto',
                            formatter: '{value} %'
                        },
                        iconStyle: {
                            borderColor: '#333'
                        }
                    },
                    calculable: true,
                    xAxis: [
                        {
                            type: 'category',
                            data: this.studyTime1,
                            axisLabel: {
                                show: true,
                                textStyle: {
                                    color: "#333",
                                    fontSize: 13,
                                }
                            },
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            axisLabel:{formatter:'{value} %'},
                            max : 100,
                            min : 0,
                            splitNumber : 5,
                            boundaryGap : [ 0.2, 0.2 ],
                            axisLabel: {
                                show: true,
                                textStyle: {
                                    color: "#333",
                                    fontSize: 13,
                                }
                            },
                        }
                    ],
                    series: [
                        {
                            name: '单词数量',
                            type: 'line',
                            data: this.studyNum1,
                            markPoint: {
                                data: [
                                    {type: 'max', name: '最大值'},
                                    {type: 'min', name: '最小值'}
                                ]
                            },

                        },
                        {
                            name: '语法数量',
                            type: 'line',
                            data: this.studyNum2,
                            markPoint: {
                                data: [
                                    {name: '年最高', value: 182.2, xAxis: 7, yAxis: 183},
                                    {name: '年最低', value: 2.3, xAxis: 11, yAxis: 3}
                                ]
                            },

                        }
                    ]
                });
            }
        }
    }
</script>

<style scoped lang='less'></style>